var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart06-template',{attrs:{"data-type":_vm.dataType,"size":_vm.size,"reload-count":_vm.reloadCount,"orientation":_vm.orientation,"unit":"건","board-ids":[107],"title":"(시설물)안전·보건 교육 현황","field-code":"facility","graph-id":77}})
}
var staticRenderFns = []

export { render, staticRenderFns }